// src/components/ScrollResetWrapper.tsx
import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

interface ScrollResetWrapperProps {
  children: React.ReactNode;
  backgroundColor?: string;
}

const ScrollResetWrapper: React.FC<ScrollResetWrapperProps> = ({
  children,
  backgroundColor = 'transparent',
}) => {
  const scrollableRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  useEffect(() => {
    if (scrollableRef.current) {
      scrollableRef.current.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [location.pathname, location.search]);

  return (
    <Box
      ref={scrollableRef}
      className="app-scroll-container"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        // dvh tracks the visible viewport as mobile browser chrome appears/disappears
        minHeight: '100dvh',
        maxHeight: '100dvh',
        overflowY: 'scroll',
        overflowX: 'hidden',
        backgroundColor,
      }}
    >
      {children}
    </Box>
  );
};

export default ScrollResetWrapper;
